import { render, staticRenderFns } from "./RcvPL_List.vue?vue&type=template&id=3155f248"
import script from "./RcvPL_List.vue?vue&type=script&lang=js"
export * from "./RcvPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports